import React from 'react';
import AppSettingsEditor from 'appToolbar/AppSettingsEditor';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useDispatchUpdateAppSettings } from 'app/store/appSettings/dispatcher';
import { useSelectIsAppModeNewportSingleWidget } from 'app/store/general/selectors';
import { ToggleInput } from '@instinet-analytics/semantic-ui-components';
import { useOpenSubmissionsConfigurationSelector } from '../store/configuration/selectors';
import { OpenSubmissionsConfiguration } from '../store/configuration/OpenSubmissionsConfiguration';
import { useDispatchUpdateWidgetConfiguration } from 'widgets/store/configuration/hooks';

export interface OpenSubmissionsSettingsProps {
    widgetKey: string;
}

export default function OpenSubmissionsSettings(
    props: OpenSubmissionsSettingsProps
) {
    const { widgetKey } = props;

    const isAppModeNewportSingleWidget =
        useSelectIsAppModeNewportSingleWidget();
    const appSettings = useSelectAppSettings();
    const dispatchUpdateAppSettings = useDispatchUpdateAppSettings();
    const dispatchUpdateWidgetConfig = useDispatchUpdateWidgetConfiguration();

    const { hideGrid, hideDoughnut } =
        useOpenSubmissionsConfigurationSelector(widgetKey);

    const onToggleShowPie = () => {
        const delta: Partial<OpenSubmissionsConfiguration> = {
            hideDoughnut: !hideDoughnut,
        };
        if (delta.hideDoughnut) {
            delta.hideGrid = false;
        }
        dispatchUpdateWidgetConfig(delta);
    };

    const onToggleShowGrid = () => {
        const delta: Partial<OpenSubmissionsConfiguration> = {
            hideGrid: !hideGrid,
        };
        if (delta.hideGrid) {
            delta.hideDoughnut = false;
        }
        dispatchUpdateWidgetConfig(delta);
    };

    return (
        <div className="OpenSubmissionsSettings">
            <div className="group">
                <div className="group-header">
                    <div className="title">Views</div>
                </div>
                <div className="group-header">
                    <div className="subtitle">Pie Chart</div>
                    <ToggleInput
                        checked={!hideDoughnut}
                        onToggle={onToggleShowPie}
                    />
                </div>
                <div className="group-header">
                    <div className="subtitle">Grid</div>
                    <ToggleInput
                        checked={!hideGrid}
                        onToggle={onToggleShowGrid}
                    />
                </div>
            </div>

            {isAppModeNewportSingleWidget && (
                <AppSettingsEditor
                    appSettings={appSettings}
                    onAppSettingsChanged={dispatchUpdateAppSettings}
                    specifyVisibleControls={{
                        showChartHelp: true,
                    }}
                />
            )}
        </div>
    );
}
